import { useState, useEffect, useRef, useContext } from "react";
import context from "../store/context";

import { Link } from "react-router-dom";

import "../shimmer.css";

import BellIcon from "./icons/Bell";
import LockIcon from "./icons/Lock";
import EmailIcon from "./icons/Email";

const Notification = ({ show }) => {
  const [showNotification, setShowNotification] = useState(false);
  const {
    isVerified,
    VerifyContact,
    userInfo,
    setShowPaywall,
  } = useContext(context);

  const notificationToggleHandler = () => {
    setShowNotification(!showNotification);
  };

  const notificationRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotification(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const showPaymentNotice = userInfo.isActive !== 1;
  const showEmailNotice = !isVerified.email && userInfo.email;
  const hasNotifications = showPaymentNotice || showEmailNotice;

  return (
    <div
      ref={notificationRef}
      className={`cursor-pointer relative ${show}`}
    >
      <button
        className="relative text-[#664bc7] bg-blue-100/50 hover:bg-blue-100 transition-colors duration-200 p-1.5 rounded-full flex items-center justify-center"
        onClick={notificationToggleHandler}
      >
        {hasNotifications && (
          <>
            <div className="w-2.5 h-2.5 rounded-full bg-red-500 absolute -right-1 top-0 ring-2 ring-white"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-red-500 absolute -right-1 top-0 animate-ping"></div>
          </>
        )}
        <BellIcon styles="w-5 h-5" />
      </button>

      {showNotification && (
        <div
          className="absolute top-full mt-3 right-0 w-[330px] animate-sheet-fade overflow-hidden rounded-[28px] bg-white"
          style={{
            boxShadow:
              "0 1px 1px rgba(0,0,0,0.04), 0 12px 28px rgba(0,0,0,0.14), 0 28px 56px rgba(0,0,0,0.22), inset 0 0 0 1px rgba(0,0,0,0.04)",
          }}
        >
          <div className="relative">
            {/* header */}
            <div className="flex items-center justify-between px-5 pt-4 pb-3 border-b border-black/[0.06]">
              <h1 className="text-[17px] font-semibold tracking-tight text-gray-900">
                Notifications
              </h1>
            </div>

            {/* list */}
            <div className="max-h-[340px] overflow-y-auto divide-y divide-black/[0.06]">
              {hasNotifications ? (
                <>
                  {showPaymentNotice && (
                    <div className="flex items-start gap-3 px-4 py-4 active:bg-black/[0.03] transition-colors">
                      <span className="mt-0.5 w-9 h-9 rounded-full bg-[#664bc7]/10 flex items-center justify-center shrink-0">
                        <LockIcon styles="w-[18px] h-[18px] text-[#664bc7]" />
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-[13.5px] leading-snug text-gray-700">
                          የiChereta አካውንቶ አክቲቭ አይደለም ፣ ጨረታዎችን ለመመልከት ክፍያ ይፍጽሙ!
                        </p>
                        <button
                          onClick={() => setShowPaywall(true)}
                          className="mt-3 inline-flex items-center justify-center h-9 px-6 rounded-full bg-[#664bc7] text-white text-[14px] font-semibold shadow-sm active:scale-95 transition-transform"
                        >
                          ይክፈሉ!
                        </button>
                      </div>
                    </div>
                  )}

                  {showEmailNotice && (
                    <div className="flex items-start gap-3 px-4 py-4 active:bg-black/[0.03] transition-colors">
                      <span className="mt-0.5 w-9 h-9 rounded-full bg-orange-400/15 flex items-center justify-center shrink-0">
                        <EmailIcon styles="w-[18px] h-[18px] text-orange-500" />
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-[14px] font-semibold text-gray-900">
                          Verify your email
                        </p>
                        <p className="mt-0.5 text-[12.5px] text-gray-500 truncate">
                          {userInfo.email}
                        </p>
                        <Link
                          to="verification/email"
                          onClick={() => {
                            VerifyContact(`email=${userInfo.email}&for=email`);
                          }}
                          className="mt-3 inline-flex items-center justify-center h-9 px-6 rounded-full bg-orange-400 text-white text-[14px] font-semibold shadow-sm active:scale-95 transition-transform"
                        >
                          Verify
                        </Link>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="px-5 py-12 text-center">
                  <div className="mx-auto mb-3 w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center">
                    <BellIcon styles="w-7 h-7 text-gray-400" />
                  </div>
                  <p className="text-[14px] font-medium text-gray-500">
                    You're all caught up
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notification;
